import { useChatsState } from 'hooks/chats/useChatsState';

export const useActiveChatRoom = () => {
  const { activeChatRoom } = useChatsState();

  return activeChatRoom;
};
